<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
          <h3 class="text-decoration-underline" style="color: coral;">
            Migration Manager (Only for TMC Support)</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              id="migrationManagerDataMigration"
              class="migration-manager-data-migration-btn"
              color="primary"
              @click="dataMigration"
            >
              Migration New Tax Unit Setup
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              id="migrationManagerDataMigration"
              class="migration-manager-data-migration-btn"
              color="primary"
              @click="dataMigrationForMisc"
            >
              Migration New TaxUnitCode Setup for MISC
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              id="migrationManagerNameLengthCap"
              class="migration-manager-data-migration-btn"
              color="primary"
              @click="dataMigrationForNameLengthCap"
            >
              Cap TaxInquiryTransaction Name1/Name2 Length
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  data: () => ({
    overlay: false,
  }),
  computed: {
  },
  created() {
  },
  methods: {
    ...mapActions('MigrationManager', ['migrateData']),
    async dataMigration() {
      if (window.confirm('Are you sure?')) {
        this.overlay = true;

        try {
          await this.migrateData({
            migrationName: '2024.08.23-taxLevy-toUnitDescForAppro',
            direction: 'up',
          });
          await this.migrateData({
            migrationName: '2024.08.27-taxDistrict-toUnitDescForAppro',
            direction: 'up',
          });
          await this.migrateData({
            migrationName: '2024.08.27-taxFund-toUnitDescForAppro',
            direction: 'up',
          });
        } catch (error) {
          console.error('Error during migration:', error);
          window.alert('An error occurred during migration. Please check the console for details.');
        } finally {
          this.overlay = false;
        }
      }
    },
    async dataMigrationForMisc() {
      if (window.confirm('Are you sure?')) {
        this.overlay = true;

        try {
          await this.migrateData({
            migrationName: '2025.02.17-taxUnit-linkToMisc',
            direction: 'up',
          });
          await this.migrateData({
            migrationName: '2025.02.19-taxUnit-fiscalYear',
            direction: 'up',
          });
        } catch (error) {
          console.error('Error during migration:', error);
          window.alert('An error occurred during migration. Please check the console for details.');
        } finally {
          this.overlay = false;
        }
      }
    },
    async dataMigrationForNameLengthCap() {
      if (window.confirm('Are you sure?')) {
        this.overlay = true;

        try {
          await this.migrateData({
            migrationName: '2026.08.10-taxinquirytransaction-name-length-cap',
            direction: 'up',
          });
        } catch (error) {
          console.error('Error during migration:', error);
          window.alert('An error occurred during migration. Please check the console for details.');
        } finally {
          this.overlay = false;
        }
      }
    },
    async dataRollback() {
      if (window.confirm('Are you sure?')) {
        this.overlay = true;
        /* rollback api */
        this.overlay = false;
      }
    },
  },
};
</script>
